import { IWebApiRequestBody } from '@cmctechnology/webinvest-api-client-web-trading';
import { frontendActions, FrontendLocations } from '@cmctechnology/webinvest-store-frontend';
import { Dispatch } from '@reduxjs/toolkit';
import { ApiRequest } from './models/apiRequest';
import { actions, ClientStore, CLIENT_STORE_NAME } from './store';
import { PendingOnlineApplicationsMode1 } from './types';

type GetState = typeof ClientStore.getState;

const PENDING_ONLINE_APPLICATIONS_POLL_TIMEOUT = 60_000;

export const fetchPendingOnlineApplications = () => {
  return async (dispatch: Dispatch<any>, getState: GetState) => {
    const hash = getState().client.intermediary.pendingOnlineApplications.hash;
    const request: IWebApiRequestBody = {
      _config: {
        hash: hash
      }
    };

    try {
      const response = await frontendActions.webTradingApiCall<PendingOnlineApplicationsMode1>(
        CLIENT_STORE_NAME,
        ApiRequest.ClientPendingOnlineApplicationsGet1,
        request,
        dispatch
      );
      dispatch<any>(actions.pendingOnlineApplicationFetched({ response, hash: response?._apiInfo?.Hash ?? 0 }));
    } catch {}
  };
};

// eslint-disable-next-line unicorn/consistent-function-scoping
export const onPollPendingOnlineApplications = () => {
  return (dispatch: Dispatch<any>) => dispatch<any>(fetchPendingOnlineApplications());
};

export const subscribePendingOnlineApplications = (location: FrontendLocations) => (dispatch: Dispatch<any>) => {
  dispatch<any>(
    frontendActions.subscribe({
      onPoll: onPollPendingOnlineApplications,
      location,
      apiName: ApiRequest.ClientPendingOnlineApplicationsGet1,
      storeName: CLIENT_STORE_NAME,
      resourceKeys: [],
      pollTimeout: PENDING_ONLINE_APPLICATIONS_POLL_TIMEOUT
    })
  );
};

export const unsubscribePendingOnlineApplications = (location: FrontendLocations) => (dispatch: Dispatch<any>) => {
  dispatch<any>(
    frontendActions.unsubscribe({
      location,
      apiName: ApiRequest.ClientPendingOnlineApplicationsGet1,
      storeName: CLIENT_STORE_NAME,
      resourceKeys: []
    })
  );
};
